import { __Type, TObject } from 'ca-middleware';
@__Type({ name: 'MapConfig', namespace: 'http://www.gsafety.com' })
export default class MapConfig extends TObject {
    private map: object;
    private baseLayers: [];
    private baseLayer3d: [];
    private switchLayers: [];
    private map3d: object;

    get Map() {
        return this.map;
    }

    set Map(value: object) {
        this.map = value;
    }

    get BaseLayers() {
        return this.baseLayers;
    }

    set BaseLayers(value: []) {
        this.baseLayers = value;
    }

    get BaseLayer3d() {
        return this.baseLayer3d;
    }

    set BaseLayer3d(value: []) {
        this.baseLayer3d = value;
    }

    get SwitchLayers() {
        return this.switchLayers;
    }

    set SwitchLayers(value: []) {
        this.switchLayers = value;
    }
    get Map3D() {
        return this.map3d;
    }

    set Map3D(value: object) {
        this.map3d = value;
    }
}
